module.exports = __webpack_public_path__ + "img/CPTemp12.949b5677.png";